module.exports = {
  theme: 'var(--color-theme)',
  theme20: 'var(--color-theme20)',
  bgBase: 'var(--color-bgBase)',
  content: 'var(--color-content)',
  content2: 'var(--color-content2)',
  content3: 'var(--color-content3)',
  contentLite: 'var(--color-contentLite)',
  subText: 'var(--color-subText)',
  grey: 'var(--color-grey)',
  grey90: 'var(--color-grey90)',
  grey80: 'var(--color-grey80)',
  grey60: 'var(--color-grey60)',
  grey70: 'var(--color-grey70)',
  grey50: 'var(--color-grey50)',
  grey40: 'var(--color-grey40)',
  grey30: 'var(--color-grey30)',
  grey20: 'var(--color-grey20)',
  grey10: 'var(--color-grey10)',
  greyLight: 'var(--color-greyLight)',
  grey12: 'var(--color-grey12)',
  primary: 'var(--color-primary)',
  primary5: 'var(--color-primary5)',
  primary10: 'var(--color-primary10)',
  primary20: 'var(--color-primary20)',
  primary30: 'var(--color-primary30)',
  primary40: 'var(--color-primary40)',
  primary50: 'var(--color-primary50)',
  primary70: 'var(--color-primary70)',
  primary80: 'var(--color-primary80)',
  primary90: 'var(--color-primary90)',
  primary100: 'var(--color-primary100)',
  primary110: 'var(--color-primary110)',
  primaryLite: 'var(--color-primaryLite)',
  primaryLite1: 'var(--color-primaryLite1)',
  primaryLite3: 'var(--color-primaryLite3)',
  primaryLite5: 'var(--color-primaryLite5)',
  primaryLite6: 'var(--color-primaryLite6)',
  primaryLite7: 'var(--color-primaryLite7)',
  primaryLite8: 'var(--color-primaryLite8)',
  primaryLite9: 'var(--color-primaryLite9)',
  primaryLite11: 'var(--color-primaryLite11)',
  primaryLiteBg: 'var(--color-primaryLiteBg)',
  error: 'var(--color-error)',
  error5: 'var(--color-error5)',
  error10: 'var(--color-error10)',
  error20: 'var(--color-error20)',
  error30: 'var(--color-error30)',
  error40: 'var(--color-error40)',
  error50: 'var(--color-error50)',
  errorLite: 'var(--color-errorLite)',
  errorLite3: 'var(--color-errorLite3)',
  errorLite5: 'var(--color-errorLite5)',
  disabledContent: 'var(--color-disabledContent)',
  disabledContentGrey: 'var(--color-disabledContentGrey)',
  borderGrey1: 'var(--color-borderGrey1)',
  borderGrey2: 'var(--color-borderGrey2)',
  borderGrey3: 'var(--color-borderGrey3)',
  borderGrey5: 'var(--color-borderGrey5)',
  borderGrey6: 'var(--color-borderGrey6)',
  borderGrey7: 'var(--color-borderGrey7)',
  bgGrey: 'var(--color-bgGrey)',
  bgGrey15: 'var(--color-bgGrey15)',
  bgGrey20: 'var(--color-bgGrey20)',
  bgGrey40: 'var(--color-bgGrey40)',
  bgGrey50: 'var(--color-bgGrey50)',
  bgGrey60: 'var(--color-bgGrey60)',
  bgGrey70: 'var(--color-bgGrey70)',
  bgGrey80: 'var(--color-bgGrey80)',
  bgGrey90: 'var(--color-bgGrey90)',
  textblack: 'var(--color-textblack)',
  neutral: 'var(--color-neutral)',
  greyStroke: 'var(--color-greyStroke)',
  greyBorder: 'var(--color-greyBorder)',
  verifiedGreen: 'var(--color-verifiedGreen)',
  lightGreen: 'var(--color-lightGreen)',
  darkGrey: 'var(--color-darkGrey)',
  selectionPrimary: 'var(--color-selectionPrimary)',
  whiteBorder: 'var(--color-whiteBorder)',
  yellow: 'var(--color-yellow)',
  yellow10: 'var(--color-yellow10)',
  yellow20: 'var(--color-yellow20)',
  yellow30: 'var(--color-yellow30)',
  yellow40: 'var(--color-yellow40)',
  yellow50: 'var(--color-yellow50)',
  yellow60: 'var(--color-yellow60)',
  yellow70: 'var(--color-yellow70)',
  yellowLite2: 'var(--color-yellowLite2)',
  yellowLite3: 'var(--color-yellowLite3)',
  yellowLite4: 'var(--color-yellowLite4)',
  grey1: 'var(--color-grey1)',
  grey2: 'var(--color-grey2)',
  grey3: 'var(--color-grey3)',
  blueGrey: 'var(--color-blueGrey)',
  warningYellow: 'var(--color-warningYellow)',
  meroon: 'var(--color-meroon)',
  blue: 'var(--color-blue)',
  blue1: 'var(--color-blue1)',
  blue2: 'var(--color-blue2)',
  blue3: 'var(--color-blue3)',
  blue4: 'var(--color-blue4)',
  blue5: 'var(--color-blue5)',
  blue6: 'var(--color-blue6)',
  blue7: 'var(--color-blue7)',
  greyText1: 'var(--color-greyText1)',
  darkText: 'var(--color-darkText)',
  pink10: 'var(--color-pink10)',
  pink20: 'var(--color-pink20)',
  brown10: 'var(--color-brown10)',
  attendanceAbsent: 'var(--color-attendanceAbsent)',
  attendancePresent: 'var(--color-attendancePresent)',
  attendanceText: 'var(--color-attendanceText)',
  progressBar: 'var(--color-progressBar)',
  progressBarText: 'var(--color-progressBarText)',
  grayDisabled: 'var(--color-grayDisabled)',
  blue8: 'var(--color-blue8)',
  orange: 'var(--color-orange)',
  green1: 'var(--color-green1)',
  pink40: 'var(--color-pink40)',
  orange10: 'var(--color-orange10)',
  content10: 'var(--color-content10)',
  content11: 'var(--color-content11)',
  warningRed: 'var(--color-warningRed)',
  progressBarBg: 'var(--color-progressBarBg)',
  primary4: 'var(--color-primary4)',
  primary4Gradient: 'var(--color-primary4Gradient)',

  // New Color List as per design patter
  // Do not create any new color below this line.
  // Use existing ones or create with above ones
  cofeePrimary1: 'var(--color-cofee-primary1)',
  cofeePrimary2: 'var(--color-cofee-primary2)',
  cofeePrimary3: 'var(--color-cofee-primary3)',
  cofeePrimary4: 'var(--color-cofee-primary4)',
  cofeePrimary5: 'var(--color-cofee-primary5)',
  cofeePrimary6: 'var(--color-cofee-primary6)',
  cofeePrimary7: 'var(--color-cofee-primary7)',
  cofeePrimary8: 'var(--color-cofee-primary8)',
  cofeePrimary9: 'var(--color-cofee-primary9)',
  cofeePrimary10: 'var(--color-cofee-primary10)',
  cofeeNeutral1: 'var(--color-cofee-neutral1)',
  cofeeNeutral2: 'var(--color-cofee-neutral2)',
  cofeeNeutral3: 'var(--color-cofee-neutral3)',
  cofeeNeutral4: 'var(--color-cofee-neutral4)',
  cofeeNeutral5: 'var(--color-cofee-neutral5)',
  cofeeNeutral6: 'var(--color-cofee-neutral6)',
  cofeeNeutral7: 'var(--color-cofee-neutral7)',
  cofeeNeutral8: 'var(--color-cofee-neutral8)',
  cofeeNeutral9: 'var(--color-cofee-neutral9)',
  cofeeNeutral10: 'var(--color-cofee-neutral10)',
  cofeeNeutral11: 'var(--color-cofee-neutral11)',
  cofeeNeutral12: 'var(--color-cofee-neutral12)',
  cofeeNeutral13: 'var(--color-cofee-neutral13)',
  cofeeNeutral14: 'var(--color-cofee-neutral14)',
  cofeeNeutralBg: 'var(--color-cofee-neutralBg)',
  cofeeNeutralInactive: 'var(--color-cofee-neutralInactive)',
  cofeeRed1: 'var(--color-cofee-red1)',
  cofeeRed2: 'var(--color-cofee-red2)',
  cofeeRed3: 'var(--color-cofee-red3)',
  cofeeRed4: 'var(--color-cofee-red4)',
  cofeeRed5: 'var(--color-cofee-red5)',
  cofeeRed6: 'var(--color-cofee-red6)',
  cofeeRed7: 'var(--color-cofee-red7)',
  cofeeRed8: 'var(--color-cofee-red8)',
  cofeeRed9: 'var(--color-cofee-red9)',
  cofeeRed10: 'var(--color-cofee-red10)',
  cofeeYellow1: 'var(--color-cofee-yellow1)',
  cofeeYellow2: 'var(--color-cofee-yellow2)',
  cofeeYellow3: 'var(--color-cofee-yellow3)',
  cofeeYellow4: 'var(--color-cofee-yellow4)',
  cofeeYellow5: 'var(--color-cofee-yellow5)',
  cofeeYellow6: 'var(--color-cofee-yellow6)',
  cofeeYellow7: 'var(--color-cofee-yellow7)',
  cofeeYellow8: 'var(--color-cofee-yellow8)',
  cofeeYellow9: 'var(--color-cofee-yellow9)',
  cofeeYellow10: 'var(--color-cofee-yellow10)',
  cofeeGreen1: 'var(--color-cofee-green1)',
  cofeeGreen2: 'var(--color-cofee-green2)',
  cofeeGreen3: 'var(--color-cofee-green3)',
  cofeeGreen4: 'var(--color-cofee-green4)',
  cofeeGreen5: 'var(--color-cofee-green5)',
  cofeeGreen6: 'var(--color-cofee-green6)',
  cofeeGreen7: 'var(--color-cofee-green7)',
  cofeeGreen8: 'var(--color-cofee-green8)',
  cofeeGreen9: 'var(--color-cofee-green9)',
  cofeeGreen10: 'var(--color-cofee-green10)',
  cofeeBlue1: 'var(--color-cofee-blue1)',
  cofeeBlue2: 'var(--color-cofee-blue2)',
  cofeeBlue3: 'var(--color-cofee-blue3)',
  cofeeBlue4: 'var(--color-cofee-blue4)',
  cofeeBlue5: 'var(--color-cofee-blue5)',
  cofeeBlue6: 'var(--color-cofee-blue6)',
  cofeeBlue7: 'var(--color-cofee-blue7)',
  cofeeBlue8: 'var(--color-cofee-blue8)',
  cofeeBlue9: 'var(--color-cofee-blue9)',
  cofeeTeal1: 'var(--color-cofee-teal1)',
  cofeeTeal2: 'var(--color-cofee-teal2)',
  cofeeTeal3: 'var(--color-cofee-teal3)',
  cofeeTeal4: 'var(--color-cofee-teal4)',
  cofeeTeal5: 'var(--color-cofee-teal5)',
  cofeeTeal6: 'var(--color-cofee-teal6)',
  cofeeTeal7: 'var(--color-cofee-teal7)',
  cofeeLime1: 'var(--color-cofee-lime1)',
  cofeeLime2: 'var(--color-cofee-lime2)',
  cofeeLime3: 'var(--color-cofee-lime3)',
  cofeeLime4: 'var(--color-cofee-lime4)',
  cofeeLime5: 'var(--color-cofee-lime5)',
  cofeeLime6: 'var(--color-cofee-lime6)',
  cofeeLime7: 'var(--color-cofee-lime7)',
  cofeePurple1: 'var(--color-cofee-purple1)',
  cofeePurple2: 'var(--color-cofee-purple2)',
  cofeePurple3: 'var(--color-cofee-purple3)',
  cofeePurple4: 'var(--color-cofee-purple4)',
  cofeePurple5: 'var(--color-cofee-purple5)',
  cofeePurple6: 'var(--color-cofee-purple6)',
  cofeePurple7: 'var(--color-cofee-purple7)',
  cofeeViolet1: 'var(--color-cofee-violet1)',
  cofeeViolet2: 'var(--color-cofee-violet2)',
  cofeeViolet3: 'var(--color-cofee-violet3)',
  cofeeViolet4: 'var(--color-cofee-violet4)',
  cofeeViolet5: 'var(--color-cofee-violet5)',
  cofeeViolet6: 'var(--color-cofee-violet6)',
  cofeeViolet7: 'var(--color-cofee-violet7)',
  cofeeOrange1: 'var(--color-cofee-orange1)',
  cofeeOrange2: 'var(--color-cofee-orange2)',
  cofeeOrange3: 'var(--color-cofee-orange3)',
  cofeeOrange4: 'var(--color-cofee-orange4)',
  cofeeOrange5: 'var(--color-cofee-orange5)',
  cofeeOrange6: 'var(--color-cofee-orange6)',
  cofeeOrange7: 'var(--color-cofee-orange7)',
  cofeeOrange8: 'var(--color-cofee-orange8)',
  cofeeRose1: 'var(--color-cofee-rose1)',
  cofeeRose2: 'var(--color-cofee-rose2)',
  cofeeRose3: 'var(--color-cofee-rose3)',
  cofeeRose4: 'var(--color-cofee-rose4)',
  cofeeRose5: 'var(--color-cofee-rose5)',
  cofeeRose6: 'var(--color-cofee-rose6)',
  cofeeRose7: 'var(--color-cofee-rose7)',
  cofeeGreyBlue1: 'var(--color-cofee-greyBlue1)',
  cofeeGreyBlue2: 'var(--color-cofee-greyBlue2)',
  cofeeGreyBlue3: 'var(--color-cofee-greyBlue3)',
  cofeeGreyBlue4: 'var(--color-cofee-greyBlue4)',
  cofeeGreyBlue5: 'var(--color-cofee-greyBlue5)',
  cofeeGreyBlue6: 'var(--color-cofee-greyBlue6)',
  cofeeGreyBlue7: 'var(--color-cofee-greyBlue7)',
  cofeeGreyBlue8: 'var(--color-cofee-greyBlue8)',
  cofeeGreyBlue9: 'var(--color-cofee-greyBlue9)',
  cofeeGreyBlue10: 'var(--color-cofee-greyBlue10)',
  cofeeGreyBlue11: 'var(--color-cofee-greyBlue11)',
  cofeeGreyBlue12: 'var(--color-cofee-greyBlue12)',
  cofeeHoverBlue: 'var(--color-cofee-hoverBlue)',
  cofeeGreyNeutral4: 'var(--color-cofee-greyNeutral4)',
  cofeeGreyNeutral5: 'var(--color-cofee-greyNeutral5)',
  cofeeGreyNeutral6: 'var(--color-cofee-greyNeutral6)',
  cofeeGreyNeutral7: 'var(--color-cofee-greyNeutral7)',
  cofeeGreyNeutral8: 'var(--color-cofee-greyNeutral8)',
  cofeeWarningYellow: 'var(--color-cofee-warning-yellow)',
  cofeeGreen11: 'var(--color-cofee-green11)',
  cofeeGreyNeutral19: 'var(--color-cofee-greyNeutral19)'
};
